import React from 'react';

const Intro = ({ intro }) => (
  <div className="c-intro u-mb-1">
    <div className="c-intro__content">
      <div className="c-intro__content__text">
        <h1 className="c-intro__content__text__title o-after-line o-after-line--purple">
          {intro?.title}
        </h1>

        <div
          className="o-text"
          dangerouslySetInnerHTML={{ __html: intro?.text }}
        ></div>
      </div>
    </div>

    <div className="c-intro__sidebar ">
      <div className="c-intro__sidebar__tm">
        <h3 className="c-intro__sidebar__tm__title">
          {intro['tailor-made']?.title}
        </h3>

        <p className="o-text">{intro['tailor-made']?.text}</p>

        <a href={intro['tailor-made']?.link?.url} className="o-btn">
          {intro['tailor-made']?.link?.title}
        </a>
      </div>
    </div>
  </div>
);

export default Intro;
